import { render, staticRenderFns } from "./master-customer.vue?vue&type=template&id=6177ae27&scoped=true"
import script from "./master-customer.vue?vue&type=script&lang=js"
export * from "./master-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6177ae27",
  null
  
)

export default component.exports